export const SOLR_VERSIONS = [
  { label: '9.10.1 (Java 21)', value: '9.10.1-java21' },
  { label: '9.10.1 (Java 11)', value: '9.10.1' },
  { label: '9.9.0 (Java 21)', value: '9.9.0-java21' },
  { label: '9.9.0 (Java 11)', value: '9.9.0' },
  { label: '9.8.1 (Java 21)', value: '9.8.1-java21' },
  { label: '9.8.1 (Java 11)', value: '9.8.1' },
];

// Default is the Java 11 version of most recent solr verson.
export const DEFAULT_COMMUNITY_SOLR_VERSION = SOLR_VERSIONS[1];

export const FILE_SIZE = { BYTES: 3145728, MEGABYTES: 3 };
export const SUPPORTED_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];
